// =============================================================================
// Lumen Viewer — keyboard shortcut registry
// =============================================================================
// Radiologists live in their keyboard. Minimal, typo-resistant registry that
// respects focused inputs (contentEditable / input / textarea).

const handlers = new Map();

function target(ev) {
  const t = ev.target;
  if (!t || t.isContentEditable) return null;
  const tag = (t.tagName || '').toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return null;
  return t;
}

function key(ev) {
  const parts = [];
  if (ev.ctrlKey || ev.metaKey) parts.push('mod');
  if (ev.shiftKey) parts.push('shift');
  if (ev.altKey) parts.push('alt');
  parts.push(ev.key.toLowerCase());
  return parts.join('+');
}

export function register(shortcuts) {
  // shortcuts: { 'w': fn, 'shift+r': fn, ... }
  for (const [combo, fn] of Object.entries(shortcuts)) {
    handlers.set(combo.toLowerCase(), fn);
  }
  return () => { for (const combo of Object.keys(shortcuts)) handlers.delete(combo.toLowerCase()); };
}

function onKeyDown(ev) {
  if (!target(ev)) return;
  const fn = handlers.get(key(ev));
  if (fn) {
    ev.preventDefault();
    fn(ev);
  }
}

let attached = false;
export function init() {
  if (attached) return;
  attached = true;
  window.addEventListener('keydown', onKeyDown);
}

export const CHEATSHEET = [
  ['W',         'Window/Level tool'],
  ['P',         'Pan'],
  ['Z',         'Zoom'],
  ['M',         'Measure (distance)'],
  ['A',         'Angle'],
  ['Shift+C',   'Cobb angle'],
  ['N',         'Annotate (arrow)'],
  ['T',         'Text annotation'],
  ['K',         'Toggle key image'],
  ['R',         'Rotate 90°'],
  ['I',         'Invert'],
  ['Esc',       'Reset view'],
  ['1–6',       'Window presets (Bone/Lung/Brain/Abd/Spine/Soft)'],
  ['← / →',     'Previous / next image'],
  ['Space',     'Toggle cine play'],
  ['F',         'Full-screen canvas'],
  ['Shift+S',   'Sign & finalize'],
  ['?',         'This cheatsheet'],
];
